import Vue from 'vue';

import cmslink from './cmslink.vue';
Vue.component( 'cmslink', cmslink );

import content from './cmscontent.vue';
Vue.component( 'cmscontent', content );

import loadingSpinner from './loading-spinner.vue';
Vue.component( 'loading-spinner', loadingSpinner );

import Icon from './Icon.vue';
Vue.component( 'Icon', Icon);

import pagination from './Pagination.vue';
Vue.component( 'Pagination', pagination );
 
import loadingWheel from './loading-wheel.vue';
Vue.component( 'loading-wheel', loadingWheel);